<template>
    <div class="field is-horizontal">
        <div class="field-label">
            <label class="label">Your Bid:</label>
        </div>
        <div class="field-body">
            <div class="field has-addons">
                <div class="control">
                    <input class="input" type="number" v-on:keyup="convertYen()" placeholder="Place your bid" v-model="amount_yen">
                </div>
                <p class="control">
                    <a class="button is-static">
                        000 ¥
                    </a>
                </p>
                <div class="control">
                    <input class="input" type="number" v-on:keyup="convertUsd()" placeholder="Place your bid" v-model="amount_usd">
                </div>
                <p class="control">
                    <a class="button is-static">
                        $
                    </a>
                </p>
            </div>
        </div>
    </div>
</template>

<script>
    import apiBids from '../../../../api/apiBids'
    import apiRates from '../../../../api/apiRates'
    export default {
        props: ['bid'],
        data() {
            return {
                amount_yen: this.$store.getters.getCurrentBidAmountYen,
                amount_usd: this.$store.getters.getCurrentBidAmountUsd
            }
        },
        methods: {
            convertYen() {
                setTimeout(function () {
                    this.$store.dispatch('changePlaceBidLoadingStatus', true)
                    const query = {amount_yen: this.amount_yen}
                    apiRates
                        .convertYenRequest(query)
                        .then((response) => {
                            this.$store.dispatch('changeCurrentBidAmountUsd', response.data)
                            this.$store.dispatch('changeCurrentBidAmountYen', this.amount_yen)
                            this.amount_usd = response.data
                            this.$store.dispatch('changePlaceBidLoadingStatus', false)
                        })
                        .catch((err) => {
                            console.log(err)
                            this.$store.dispatch('changePlaceBidLoadingStatus', false)
                        })
                }.bind(this), 1000)
            },
            convertUsd() {
                setTimeout(function () {
                    this.$store.dispatch('changePlaceBidLoadingStatus', true)
                    const query = { amount_usd: this.amount_usd }
                    apiRates
                        .convertUsdRequest(query)
                        .then((response) => {
                            this.$store.dispatch('changeCurrentBidAmountYen', response.data)
                            this.$store.dispatch('changeCurrentBidAmountUsd', this.amount_usd)
                            this.amount_yen = response.data
                            this.$store.dispatch('changePlaceBidLoadingStatus', false)
                        })
                        .catch((err) => {
                            console.log(err)
                            this.$store.dispatch('changePlaceBidLoadingStatus', false)
                        })
                }.bind(this), 1000)
            }
        },
        mounted () {
            if (this.bid.bids.length > 0 === true) {
                this.$store.dispatch('changeCurrentBidAmountYen', this.bid.bids[0].amount_yen)
                this.$store.dispatch('changeCurrentBidAmountUsd', this.bid.bids[0].amount_usd)
                this.amount_yen = this.bid.bids[0].amount_yen
                this.amount_usd = this.bid.bids[0].amount_usd
            }
        }
    }

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Auctions/Lot/Modal/BidInput.vue